<template>
  <div class="lang-cont" @mouseenter="show = true" @mouseleave="show = false">
    <div class="lang-wrap">
      <lang-icon class="lang-icon"></lang-icon>
      <span v-if="$i18n.locale == 'ru'">
        Русский
      </span>
      <span v-if="$i18n.locale == 'en'">
        English
      </span>
      <svg :style="{transform: show ? 'rotate(180deg)' : ''}" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.5">
          <path d="M10.0042 12.8333C9.82084 12.8333 9.65417 12.7666 9.52083 12.6333L5.35416 8.29995C5.10416 8.03329 5.10416 7.61662 5.37083 7.34996C5.63749 7.09996 6.05417 7.09996 6.32084 7.36663L10.0042 11.2L13.6875 7.36663C13.9375 7.09996 14.3708 7.09996 14.6375 7.34996C14.9042 7.59996 14.9042 8.03329 14.6542 8.29995L10.4875 12.6333C10.3542 12.7666 10.1875 12.8333 10.0042 12.8333Z" fill="white"/>
        </g>
      </svg>
    </div>
    <lang-switcher class="lang-switcher" :show-lang-switcher="show"></lang-switcher>
  </div>
</template>

<script>
  import langSwitcher from '../../langSwitcher'
  import langIcon from '../../Svg/langIcon'

  export default {
    name: 'langCont',
    data() {
      return {
        show: false,
      }
    },
    components: {
      langSwitcher,
      langIcon
    }
  }
</script>

<style lang="scss" scoped>
.lang-cont {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  padding-bottom: 20px;

  svg {
    margin-left: 12px;
    transition: $anim;
  }
}

  .lang-wrap {
    display: flex;
    align-items: center;
  }

  .lang-icon {
    margin-right: 15px;
  }

  span {
    font-family: $mr;
    font-size: 14px;
    letter-spacing: 0.25px;
    color: white;
    cursor: pointer;
  }

  .lang-switcher {
    position: absolute;
    right: 0;
    top:100%;

    &::before {
      top: -5px;
      bottom: auto;
      left: auto;
      right: 53px;
    }
  }
</style>
